import { useEffect, useRef } from 'react';
export function useWhenMounted(cb, deps) {
    const isMountedRef = useRef(false);
    useEffect(() => {
        if (isMountedRef.current) {
            cb();
        }
        isMountedRef.current = true;
    }, [...deps]);
}
//# sourceMappingURL=index.js.map